import React from 'react';

import { BaseIconProps } from '.';

export const ChevronForward = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(43.2,0,0,43.2,-14417.87,-60123.47)"
    d="m 346.247,1391.747 -2.203,2.203 8.719,8.734 h -19.016 v 3.125 h 19.016 l -8.72,8.735 2.204,2.203 12.5,-12.5 z"
    fill={fill}
  />
);
